var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimariesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.942,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-478 -1941)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478 1941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.775,0A29.775,29.775,0,1,1,0,29.775,29.775,29.775,0,0,1,29.775,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.029 1946)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.91,35.961,21.973,37a.853.853,0,0,0,1.195-.006l5.658-5.66a.849.849,0,0,0,0-1.2l-.013-.013,1.5-1.5a.855.855,0,0,0,.208-.851l2.017-2.019a.846.846,0,0,0,0-1.2l-.3-.3c.117-.111.226-.216.331-.317l.394.394a.85.85,0,1,0,1.2-1.2l-.382-.382a13.737,13.737,0,0,0,2.132-6.106c.124-1.729.029-7.783-6.352-13.072-6.4-5.3-15.569-4.1-21.323-.178C2.366,7.391-2.134,15.348,1.06,24.086A16.188,16.188,0,0,0,12.5,34.739a20.511,20.511,0,0,0,6.67.587C12.938,41.862,7.519,46.172,2.633,48.474c-.354.166-.69.308-1.027.455Q2.47,49.494,3.377,50c5.207-2.457,10.949-7.056,17.533-14.041m8.479-9.471-2.409-2.409,1.346-1.346,2.409,2.411Zm1.646-3.448-.681-.681c.107-.124.21-.239.3-.346l.713.711c-.1.1-.216.205-.333.317M12.871,33.079A14.4,14.4,0,0,1,2.658,23.5C-.223,15.623,3.867,8.424,9.2,4.787a18.273,18.273,0,0,1,10.079-3.1,14.209,14.209,0,0,1,9.2,3.178c5.758,4.773,5.851,10.119,5.742,11.643a12.017,12.017,0,0,1-1.671,4.993l-.866-.866a12.864,12.864,0,0,0,1.281-3.849c.423-2.719-1.373-7.507-5.111-10.806C23.18,1.857,14.652,2.57,9.923,5.792c-4.87,3.32-8.658,9.9-6.14,17.129,3.069,8.8,11.42,9.509,13.536,9.544l1.224,1.193a18.843,18.843,0,0,1-5.672-.579m5.513-3.989.342.958-1.142.721c-1.134.034-9.272-.023-12.194-8.408C3.014,15.55,6.863,9.934,10.881,7.2a15.376,15.376,0,0,1,8.366-2.362,11.3,11.3,0,0,1,7.484,2.425c2.209,1.952,5.023,6.259,4.553,9.272a10.969,10.969,0,0,1-.872,2.836l-.063-.063a.85.85,0,0,0-1.2,1.2l.3.3-.3.348-.222-.222a.85.85,0,0,0-1.2,0L25.861,22.8a.847.847,0,0,0-.574-.235h-.006a.853.853,0,0,0-.639.287,43.073,43.073,0,0,1-3.6,3.6A10.452,10.452,0,0,1,18.9,28.006a.848.848,0,0,0-.511,1.084m.713,2.734,1.111-.7a.85.85,0,0,0,.348-1l-.327-.916a17.914,17.914,0,0,0,1.914-1.457A38.781,38.781,0,0,0,25.2,24.759l3.281,3.281-.872.874-.2-.2a.85.85,0,1,0-1.2,1.2l.8.8,0,0,0,0,.01.01-4.465,4.465Z",
    transform: "translate(0 0)",
    fill: "#0d1c4b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimariesIcon);
export default __webpack_public_path__ + "static/media/primaries-icon.987f2403eaf17abaf63a293327c755e2.svg";
export { ForwardRef as ReactComponent };